import {defineAsyncComponent} from 'vue';

// phân hệ tài khoản
const popupAccountCategoryDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/accountCategory/AccountCategoryDetail.vue'),
);

// phân hệ ngân hàng
const popupCurrencyDetail = defineAsyncComponent(() => import('@/views/dictionary/currency/CurrencyDetail.vue'));

// phân hệ tài sản/tang vật
const popupAssetCategoryDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/assetCategory/AssetCategoryDetail.vue'),
);
const popupStockDetail = defineAsyncComponent(() => import('@/views/dictionary/stock/StockDetail.vue'));
const popupAssetDetail = defineAsyncComponent(() => import('@/views/dictionary/asset/AssetDetail.vue'));

// phân hệ khác
const popupReceiptDetail = defineAsyncComponent(() => import('@/views/dictionary/receipt/ReceiptDetail.vue'));
const popupListCodeDetail = defineAsyncComponent(() => import('@/views/dictionary/listCode/ListCodeDetail.vue'));
const popupAreaDetail = defineAsyncComponent(() => import('@/views/dictionary/area/AreaDetail.vue'));

const popupJusticeDecisionGroupDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/justiceDecisionGroup/JusticeDecisionGroupDetail.vue'),
);
const popupAccountingObjectDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/accountingObject/AccountingObjectDetail.vue'),
);

// Các loại đối tượng riêng
const popupBailiffDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/bailiffs/BailiffDetail.vue'),
);
const popupExcutionObjectDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/excutionObject/ExcutionObjectDetail.vue'),
);
const popupExcutedObjectDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/excutedObject/ExcutedObjectDetail.vue'),
);
const popupSupplierDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/supplier/SupplierDetail.vue'),
);
const popupPeopleCommiteeDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/peopleCommitee/PeopleCommiteeDetail.vue'),
);
const popupObjectDifferentDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/objectDifferent/ObjectDifferentDetail.vue'),
);

const popupJusticeCaseDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/justiceCase/JusticeCaseDetail.vue'),
);

const popupJusticeCaseTypeDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/justiceCaseType/JusticeCaseTypeDetail.vue'),
);

const popupImportedObjectDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/importChequeIssue/ImportedObjectDetail.vue'),
);

const popupImportedDecisionListDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/importChequeIssue/ImportedDecisionListDetail.vue'),
);

const popupImportedAssetListDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/importInwardStock/ImportedAssetListDetail.vue'),
);
// tài khoản
const popupAccountDetails = defineAsyncComponent(() =>
  import('@/views/dictionary/systemAccounts/AccountDetails.vue'),
);

// chuyển tài khoản hạch toán
const popupTransferPostedAccount = defineAsyncComponent(() => import('@/views/dictionary/systemAccounts/TransferPostedAccount.vue'));

// ngân hàng
const popupBankStandardDetail = defineAsyncComponent(() => import('@/views/dictionary/bankStandard/BankStandardDetail.vue'));
const popupBankInfoDetail = defineAsyncComponent(() => import('@/views/dictionary/bankInfo/BankInfoDetail.vue'));
const popupBranchDetail = defineAsyncComponent(() => import('@/views/dictionary/branch/BranchDetail.vue'));

// tài khoản kết chuyển
const popupAccountTransferDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/accountTransfer/AccountTransferDetail.vue'),
);

// tài khoản ngầm định
const popupDefaultAccountDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/defaultAccount/DefaultAccountDetail.vue'),
);

// Thay đổi chấp hành viên
const popupChangeObject = defineAsyncComponent(() => import('@/views/dictionary/changeObject/ChangeObject.vue')); 

// Chuyển CHV theo dõi QĐ THA
const popupTransferCHV = defineAsyncComponent(() => import('@/views/dictionary/transferExecutor/TransferExecutor.vue'));

// Thiết lập quy tắc lập chứng từ cho biên lai
const popupTicketRuleSetting = defineAsyncComponent(() => import('@/views/ticket/ticketRuleSetting/TicketRuleSetting.vue'));
// Kết quả sinh chứng từ từ biên lai
const popupTicketVoucherResult = defineAsyncComponent(() => import('@/views/ticket/ticketVoucherResult/TicketVoucherResult.vue'));
const popupTicketSyncPopup = defineAsyncComponent(() => import('@/views/ticket/ticketSyncPopup/TicketSyncPopup.vue'));
const popupVoucherSyncPopup = defineAsyncComponent(() => import('@/views/fptConnect/voucherSyncPopup/VoucherSyncPopup.vue'));
const popupFptAdvancePaymentReject = defineAsyncComponent(() => import('@/views/fptConnect/FptRejectPopup.vue'));
// Kết quả sinh chứng từ từ Giấy đề nghị nhập kho / LNK
const popupFptInwardStockVoucherResult = defineAsyncComponent(() => import('@/views/fptConnect/fptInwardStockVoucherResult/FptInwardStockVoucherResult.vue'));
// Kết quả sinh chứng từ từ Giấy đề nghị xuất kho / Lệnh xuất kho
const popupFptOutwardStockVoucherResult = defineAsyncComponent(() =>
  import('@/views/fptConnect/fptOutwardStockVoucherResult/FptOutwardStockVoucherResult.vue'),
);
// Kết quả lập chứng từ từ giấy đề nghị thanh toán FPT
const popupFptPayoutVoucherResult = defineAsyncComponent(() =>
  import('@/views/fptConnect/fptPayoutVoucherResult/FptPayoutVoucherResult.vue'),
);
// kiểm tra tính hợp lệ của số dư ban đầu
const popupCheckValidAmount = defineAsyncComponent(() => import('@/views/dictionary/checkValidAmount/CheckValidAmount.vue'));
// kiểm tra tính hợp lệ của chứng từ
const popupCheckValidVoucher = defineAsyncComponent(() =>
  import('@/views/dictionary/checkValidVoucher/CheckValidVoucher.vue'),
);

// Nhập khẩu phát hành séc
const popupImportChequeIssue = defineAsyncComponent(() =>
  import('@/views/dictionary/importChequeIssue/ImportChequeIssue.vue'),
);

// Nhập khẩu phiếu nhập kho
const popupImportInwardStock = defineAsyncComponent(() =>
  import('@/views/dictionary/importInwardStock/ImportInwardStock.vue'),
);

export function registerDictionary(app) {
  // phân hệ tài sản/tang vật
  app.component('AssetDetail', popupAssetDetail);
  app.component('AssetCategoryDetail', popupAssetCategoryDetail);
  app.component('StockDetail', popupStockDetail);

  // phân hệ khác
  app.component('ReceiptDetail', popupReceiptDetail);
  app.component('ListCodeDetail', popupListCodeDetail);
  app.component('AreaDetail', popupAreaDetail);
  app.component('JusticeDecisionGroupDetail', popupJusticeDecisionGroupDetail);

  // phân hệ đối tượng
  app.component('AccountingObjectDetail', popupAccountingObjectDetail);
  app.component('BailiffDetail', popupBailiffDetail);
  app.component('ExcutionObjectDetail', popupExcutionObjectDetail);
  app.component('ExcutedObjectDetail', popupExcutedObjectDetail);
  app.component('SupplierDetail', popupSupplierDetail);
  app.component('PeopleCommiteeDetail', popupPeopleCommiteeDetail);
  app.component('ObjectDifferentDetail', popupObjectDifferentDetail);

  // phân hệ quyết định
  app.component('JusticeCaseDetail', popupJusticeCaseDetail);
  app.component('JusticeCaseTypeDetail', popupJusticeCaseTypeDetail);
  app.component('BranchDetail', popupBranchDetail);

  // tài khoản
  app.component('AccountDetails', popupAccountDetails);
  app.component('TransferPostedAccount', popupTransferPostedAccount);
  app.component('AccountCategoryDetail', popupAccountCategoryDetail);
  app.component('AccountTransferDetail', popupAccountTransferDetail);
  app.component('DefaultAccountDetail', popupDefaultAccountDetail);

  // ngân hàng
  app.component('BankStandardDetail', popupBankStandardDetail);
  app.component('BankInfoDetail', popupBankInfoDetail);
  app.component('CurrencyDetail', popupCurrencyDetail);

  // Hệ thống
  app.component('ChangeObject', popupChangeObject);
  app.component('TransferCHV', popupTransferCHV);
  app.component('CheckValidAmount', popupCheckValidAmount);
  app.component('CheckValidVoucher', popupCheckValidVoucher);
  
  // Thiết lập quy tắc biên lai
  app.component('TicketRuleSetting', popupTicketRuleSetting);
  // Kết quả sinh chứng từ từ biên lai
  app.component('TicketVoucherResult', popupTicketVoucherResult);
  // Kết quả lập chứng từ từ giấy đề nghị chi FPT
  const popupFptPaymentVoucherResult = defineAsyncComponent(() => import('@/views/fptConnect/fptPaymentVoucherResult/FptPaymentVoucherResult.vue'));
  app.component('FptPaymentVoucherResult', popupFptPaymentVoucherResult);
  // Kết quả lập chứng từ từ giấy đề nghị tạm ứng FPT
  const popupFptAdvanceRequestVoucherResult = defineAsyncComponent(() => import('@/views/fptConnect/fptAdvanceRequestVoucherResult/FptAdvanceRequestVoucherResult.vue'));
  app.component('FptAdvanceRequestVoucherResult', popupFptAdvanceRequestVoucherResult);
  // Kết quả lập chứng từ từ giấy thanh toán tạm ứng FPT
  const popupFptAdvancePaymentVoucherResult = defineAsyncComponent(() => import('@/views/fptConnect/fptAdvancePaymentVoucherResult/FptAdvancePaymentVoucherResult.vue'));
  app.component('FptAdvancePaymentVoucherResult', popupFptAdvancePaymentVoucherResult);
  // Kết quả lập chứng từ từ bảng kê phân phối tiền FPT
  const popupFptDistributionMoneyVoucherResult = defineAsyncComponent(() => import('@/views/fptConnect/fptDistributionMoneyVoucherResult/FptDistributionMoneyVoucherResult.vue'));
  app.component('FptDistributionMoneyVoucherResult', popupFptDistributionMoneyVoucherResult);
  // Đồng bộ biên lai điện tử từ FPT
  app.component('TicketSyncPopup', popupTicketSyncPopup);
  app.component('VoucherSyncPopup', popupVoucherSyncPopup);
  app.component('FptRejectPopup', popupFptAdvancePaymentReject);
  // Kết quả sinh chứng từ từ Giấy đề nghị nhập kho / LNK
  app.component('FptInwardStockVoucherResult', popupFptInwardStockVoucherResult);
  // Kết quả sinh chứng từ từ Giấy đề nghị xuất kho / Lệnh xuất kho
  app.component('FptOutwardStockVoucherResult', popupFptOutwardStockVoucherResult);
  // Kết quả lập chứng từ từ giấy đề nghị thanh toán FPT
  app.component('FptPayoutVoucherResult', popupFptPayoutVoucherResult);
  
  // Nhập khẩu phát hành séc
  app.component('ImportChequeIssue', popupImportChequeIssue);
  
  // Nhập khẩu phiếu nhập kho
  app.component('ImportInwardStock', popupImportInwardStock);

  // Tab nhập khẩu thành công
  app.component('ImportedObjectDetail', popupImportedObjectDetail);
  app.component('ImportedDecisionListDetail', popupImportedDecisionListDetail);
  app.component('ImportedAssetListDetail', popupImportedAssetListDetail);
  
}
